/* ============================================================
   SIP OEE HOURLY PRODUCTION REMINDER V1
   STAGING
   - hanya membaca row OUTPUT / PRODUKSI
   - tidak menyentuh data/backend
   ============================================================ */

const SIP_OEE_REMINDER_ID = "sip-oee-production-reminder-v1";
const SIP_OEE_TOAST_ID = "sip-oee-production-hour-toast-v1";

let sipOeeLastHourKey = "";
let sipOeeObserver = null;
let sipOeeTimer = null;
let sipOeeRefreshQueued = false;

function sipOeeIsPage() {
  return /\/produksi\/oee(?:\/|$|\?)/i.test(
    window.location.pathname + window.location.search
  );
}

function sipOeeNormalizeText(v) {
  return String(v || "")
    .replace(/\s+/g, " ")
    .trim()
    .toUpperCase();
}

function sipOeeGetActiveProcess() {
  const candidates = [
    ...document.querySelectorAll(
      ".nav-link.active, .nav-item .active, .tab.active, button.active"
    ),
  ];

  const known = [
    "MACHINING",
    "MODELINE",
    "PH & SMS",
    "PRESS BLANK",
    "PRESS REG",
    "PRESS ML",
    "PRESS PROG",
    "SEAT LOCK COMP",
    "ST SHAFT",
    "SPOT",
  ];

  for (const el of candidates) {
    const txt = sipOeeNormalizeText(el.textContent);

    for (const k of known) {
      if (txt.includes(k)) return k;
    }
  }

  return "PROSES OEE";
}

function sipOeeFindHourHeaderMap(table) {
  const rows = [...table.querySelectorAll("tr")];

  for (const row of rows) {
    const cells = [...row.children];

    const labels = cells.map((cell) =>
      sipOeeNormalizeText(cell.textContent)
    );

    const map = [];

    labels.forEach((label, idx) => {
      const m = label.match(/^JAM\s*(\d+)$/);

      if (m) {
        const no = Number(m[1]);

        if (no >= 1 && no <= 10) {
          map.push({
            hour: no,
            index: idx,
          });
        }
      }
    });

    if (map.length >= 3) {
      return map.sort(
        (a,b)=>a.hour-b.hour
      );
    }
  }

  return [];
}

function sipOeeFindProductionContexts() {
  const contexts = [];

  for (const table of document.querySelectorAll("table")) {
    const rows = [...table.querySelectorAll("tr")];

    const prodRow = rows.find((row) => {
      const text = sipOeeNormalizeText(row.textContent);

      return (
        text.includes("OUTPUT / PRODUKSI") ||
        text.includes("OUTPUT/PRODUKSI")
      );
    });

    if (!prodRow) continue;

    const hourMap = sipOeeFindHourHeaderMap(table);

    if (!hourMap.length) continue;

    const cells = [...prodRow.children];

    const slots = hourMap.map(({hour,index}) => {
      const cell = cells[index] || null;

      if (!cell) {
        return {
          hour,
          cell:null,
          input:null,
          value:"",
          filled:false,
        };
      }

      const input = cell.querySelector(
        "input, select, textarea"
      );

      const rawValue = input
        ? input.value
        : String(cell.textContent || "").trim();

      // Nilai 0 / 0.00 dianggap SUDAH diinput.
      // Yang dianggap belum diinput hanya value benar-benar kosong.
      const filled =
        String(rawValue ?? "").trim() !== "";

      return {
        hour,
        cell,
        input,
        value:String(rawValue ?? "").trim(),
        filled,
      };
    });

    contexts.push({
      table,
      prodRow,
      slots,
    });
  }

  return contexts;
}

function sipOeeApplyCellClasses(contexts) {
  document
    .querySelectorAll(
      ".sip-oee-prod-hour-cell, .sip-oee-prod-hour-input"
    )
    .forEach((el) => {
      el.classList.remove(
        "sip-oee-prod-hour-cell",
        "sip-oee-prod-hour-filled",
        "sip-oee-prod-hour-missing",
        "sip-oee-prod-hour-next",
        "sip-oee-prod-hour-input"
      );
    });

  for (const ctx of contexts) {
    const next =
      ctx.slots.find((s)=>!s.filled) || null;

    ctx.prodRow.classList.add(
      "sip-oee-output-production-row"
    );

    for (const slot of ctx.slots) {
      if (!slot.cell) continue;

      slot.cell.classList.add(
        "sip-oee-prod-hour-cell"
      );

      slot.cell.classList.add(
        slot.filled
          ? "sip-oee-prod-hour-filled"
          : "sip-oee-prod-hour-missing"
      );

      if (
        next &&
        slot.hour === next.hour
      ) {
        slot.cell.classList.add(
          "sip-oee-prod-hour-next"
        );
      }

      if (slot.input) {
        slot.input.classList.add(
          "sip-oee-prod-hour-input"
        );

        slot.input.dataset.sipOeeJam =
          String(slot.hour);
      }
    }
  }
}

function sipOeeGetSummary(contexts) {
  const all = contexts.flatMap(
    (ctx)=>ctx.slots
  );

  const byHour = new Map();

  for (const slot of all) {
    const prev = byHour.get(slot.hour);

    if (!prev) {
      byHour.set(slot.hour, {
        hour:slot.hour,
        total:1,
        filled:slot.filled ? 1 : 0,
      });
    } else {
      prev.total += 1;
      if (slot.filled) prev.filled += 1;
    }
  }

  const hours = [...byHour.values()]
    .sort((a,b)=>a.hour-b.hour);

  const missing = hours.filter(
    x => x.filled < x.total
  );

  return {
    hours,
    missing,
    next:
      missing.length
        ? missing[0].hour
        : null,
    complete:
      hours.length > 0 &&
      missing.length === 0,
  };
}

function sipOeeEnsureReminder() {
  let el = document.getElementById(
    SIP_OEE_REMINDER_ID
  );

  if (el) return el;

  el = document.createElement("section");
  el.id = SIP_OEE_REMINDER_ID;
  el.className = "sip-oee-reminder-card";
  el.setAttribute(
    "aria-live",
    "polite"
  );

  document.body.appendChild(el);

  return el;
}

function sipOeeShowHourlyToast(summary) {
  const now = new Date();

  const hourKey =
    `${now.getFullYear()}-` +
    `${String(now.getMonth()+1).padStart(2,"0")}-` +
    `${String(now.getDate()).padStart(2,"0")}-` +
    `${String(now.getHours()).padStart(2,"0")}`;

  // hanya sekali setiap clock hour
  if (sipOeeLastHourKey === hourKey) {
    return;
  }

  sipOeeLastHourKey = hourKey;

  if (summary.complete || !summary.next) {
    return;
  }

  let toast = document.getElementById(
    SIP_OEE_TOAST_ID
  );

  if (!toast) {
    toast = document.createElement("div");
    toast.id = SIP_OEE_TOAST_ID;
    toast.className =
      "sip-oee-hour-toast";
    document.body.appendChild(toast);
  }

  toast.innerHTML = `
    <strong>⏰ Reminder Input Produksi</strong>
    <span>JAM ${summary.next} belum diisi. Mohon input OEE produksi tepat waktu.</span>
  `;

  toast.classList.add("show");

  window.setTimeout(() => {
    toast.classList.remove("show");
  }, 9000);
}

function sipOeeRender() {
  if (!sipOeeIsPage()) {
    const old =
      document.getElementById(
        SIP_OEE_REMINDER_ID
      );

    if (old) old.remove();

    return;
  }

  const contexts =
    sipOeeFindProductionContexts();

  if (!contexts.length) {
    const card =
      sipOeeEnsureReminder();

    card.className =
      "sip-oee-reminder-card waiting";

    card.innerHTML = `
      <div class="sip-oee-reminder-title">
        ⏰ Reminder Input Produksi / Jam
      </div>
      <div class="sip-oee-reminder-sub">
        Menunggu tabel OUTPUT / PRODUKSI tampil...
      </div>
    `;

    return;
  }

  sipOeeApplyCellClasses(contexts);

  const summary =
    sipOeeGetSummary(contexts);

  const card =
    sipOeeEnsureReminder();

  const now = new Date();

  const timeText =
    `${String(now.getHours()).padStart(2,"0")}:` +
    `${String(now.getMinutes()).padStart(2,"0")}`;

  // 10 menit pertama setiap jam reminder dibuat lebih kuat.
  const hourlyAlert =
    !summary.complete &&
    now.getMinutes() <= 9;

  card.className =
    "sip-oee-reminder-card " +
    (
      summary.complete
        ? "complete"
        : hourlyAlert
          ? "hourly-alert"
          : "incomplete"
    );

  const chips = summary.hours
    .map((x) => {
      const done =
        x.filled === x.total;

      const next =
        summary.next === x.hour;

      return `
        <span class="
          sip-oee-hour-chip
          ${done ? "done" : "pending"}
          ${next ? "next" : ""}
        ">
          JAM ${x.hour}
          ${done ? "✓" : "!"}
        </span>
      `;
    })
    .join("");

  const missingText =
    summary.missing.length
      ? summary.missing
          .map((x)=>`JAM ${x.hour}`)
          .join(", ")
      : "Tidak ada";

  const nextText =
    summary.next
      ? `JAM ${summary.next}`
      : "Semua lengkap";

  card.innerHTML = `
    <div class="sip-oee-reminder-top">
      <div>
        <div class="sip-oee-reminder-title">
          ⏰ Reminder Input Produksi / Jam
        </div>
        <div class="sip-oee-reminder-sub">
          ${sipOeeGetActiveProcess()} • ${timeText}
          • Hanya memantau OUTPUT / PRODUKSI
        </div>
      </div>

      <div class="sip-oee-reminder-next">
        <span>Berikutnya</span>
        <strong>${nextText}</strong>
      </div>
    </div>

    <div class="sip-oee-hour-chips">
      ${chips}
    </div>

    <div class="sip-oee-reminder-foot">
      ${
        summary.complete
          ? "✅ Input produksi JAM 1–10 yang tampil sudah lengkap."
          : `⚠️ Belum lengkap: ${missingText}. Pastikan user/operator/PIC melakukan input produksi tepat waktu.`
      }
    </div>
  `;

  sipOeeShowHourlyToast(summary);
}

function sipOeeQueueRefresh() {
  if (sipOeeRefreshQueued) return;

  sipOeeRefreshQueued = true;

  window.setTimeout(() => {
    sipOeeRefreshQueued = false;

    try {
      sipOeeRender();
    } catch (err) {
      console.error(
        "[SIP OEE Reminder]",
        err
      );
    }
  }, 120);
}

function sipOeeStart() {
  if (sipOeeObserver) return;

  sipOeeObserver =
    new MutationObserver(
      sipOeeQueueRefresh
    );

  sipOeeObserver.observe(
    document.documentElement,
    {
      childList:true,
      subtree:true,
    }
  );

  document.addEventListener(
    "input",
    sipOeeQueueRefresh,
    true
  );

  document.addEventListener(
    "change",
    sipOeeQueueRefresh,
    true
  );

  window.addEventListener(
    "popstate",
    sipOeeQueueRefresh
  );

  sipOeeTimer =
    window.setInterval(
      sipOeeQueueRefresh,
      30000
    );

  sipOeeQueueRefresh();
}

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    sipOeeStart,
    {once:true}
  );
} else {
  sipOeeStart();
}
